import { Component, computed, inject, Signal, signal, WritableSignal } from '@angular/core';
import {
    BackgroundColorDirective,
    ButtonDirective,
    ColorDirective,
    LoadingSpinnerComponent,
    TypographyDirective,
} from '@dartcounter/ui';
import { UserGroupsApiService } from '@dc-api/user-groups.api.service';
import { AlertService } from '@dc-core/dc-services/alert.service';
import { TranslateModule } from '@ngx-translate/core';
import { UserStateService } from 'src/app/modules/user/services/user-state.service';
import { SlideDialogLayoutComponent } from 'src/app/shared/dialogs/slide-dialog-layout/slide-dialog-layout.component';
import { ModalService } from 'src/app/shared/services/modal.service';

import { ConnectionStatus } from '../../../models/smart-devices.models';
import { OmniCommunicationService } from '../../services/omni-communication.service';

export interface OmniBetaOptInResponse {
    leftBeta: boolean;
}

@Component({
    selector: 'app-omni-beta-opt-in',
    standalone: true,
    imports: [
        TranslateModule,
        SlideDialogLayoutComponent,
        ButtonDirective,
        BackgroundColorDirective,
        TypographyDirective,
        ColorDirective,
        LoadingSpinnerComponent,
    ],
    templateUrl: './omni-beta-opt-in.component.html',
    styleUrl: './omni-beta-opt-in.component.css',
})
export class OmniBetaOptInComponent {
    private userStateService: UserStateService = inject(UserStateService);
    private userGroupsApiService: UserGroupsApiService = inject(UserGroupsApiService);
    private omniCommunicationService: OmniCommunicationService = inject(OmniCommunicationService);
    private modalService: ModalService = inject(ModalService);
    private alertService: AlertService = inject(AlertService);

    public isLoading: WritableSignal<boolean> = signal(false);
    public isBeta: Signal<boolean> = computed(
        () => !!this.userStateService.currentGroups().find((group) => group.name === 'omni_beta')
    );

    public joinBeta(): void {
        this.isLoading.set(true);
        this.userGroupsApiService.applyForGroup({ group_name: 'omni_beta' }).then((res) => {
            this.userStateService.addGroup(res.data);

            this.isLoading.set(false);
            this.dismiss();
        });
    }

    public leaveBeta(): void {
        if (this.omniCommunicationService.currentConnectionStatus() !== ConnectionStatus.CONNECTED) {
            this.alertService.createAlert({
                title: $localize`:@@OMNI_NEEDS_TO_BE_CONNECTED:Omni needs to be connected`,
                icon: 'error',
            });
            return;
        }

        this.isLoading.set(true);
        this.userGroupsApiService.leaveGroup({ group_name: 'omni_beta' }).then(() => {
            this.userStateService.removeGroup('omni_beta');

            this.isLoading.set(false);
            this.dismiss(true);
        });
    }

    public dismiss(leftBeta = false): void {
        this.modalService.dismiss({ leftBeta });
    }
}
